export { chatsActions } from "./actions";

export { ChatsActionTypes } from "./actionTypes";
export { ChatsMutationTypes } from "./mutationTypes";
export { ChatsGetterTypes } from "./getters";

import { chats } from "./modules";
export default chats;
